'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('memoryGame', {
      url: '/game/memory',
      template: '<memory-game></memory-game>'
    });
}



// WEBPACK FOOTER //
// ./client/app/games/memory/memoryGame.routes.js